<template>
  <v-card
    outlined
    class="integration-card d-flex flex-column"
    @click="$emit('click')"
  >
    <div
      class="integration-card__logo"
      :class="`integration-card__logo--${displayMode}`"
    >
      <img
        v-if="logoSrc"
        :src="logoSrc"
        :alt="integration.name"
        class="integration-card__logo-image"
        :class="`integration-card__logo-image--${displayMode}`"
      />
      <v-icon v-else color="grey lighten-1" size="56">
        mdi-puzzle-outline
      </v-icon>
    </div>

    <v-divider></v-divider>

    <v-card-title class="integration-card__title subtitle-1 py-3">
      {{ integration.name }}
    </v-card-title>

    <v-card-text class="integration-card__description body-2 pb-2">
      {{ integration.description }}
    </v-card-text>

    <v-card-actions class="integration-card__actions mt-auto pa-4 pt-0">
      <v-spacer></v-spacer>
      <v-btn small color="primary" text>
        Configurar
        <v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getIntegrationAsset } from "@/constants/integrationAssets";

export default {
  name: "IntegrationCard",
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  computed: {
    assetConfig() {
      return getIntegrationAsset(this.integration.slug);
    },
    logoSrc() {
      return this.assetConfig ? this.assetConfig.src : null;
    },
    displayMode() {
      return this.assetConfig ? this.assetConfig.displayMode : "logo";
    },
  },
};
</script>

<style scoped>
.integration-card {
  --integration-card-height: 320px;
  height: var(--integration-card-height);
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.integration-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.integration-card__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
}

.integration-card__logo--logo {
  padding: 16px;
}

.integration-card__logo--banner {
  padding: 0;
  overflow: hidden;
}

.integration-card__logo-image--logo {
  max-width: 80%;
  max-height: 88px;
  object-fit: contain;
}

.integration-card__logo-image--banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.integration-card__title {
  line-height: 1.3;
  word-break: break-word;
}

.integration-card__description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.6);
  min-height: 4.5em;
}

.integration-card__actions {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
